import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';

const TOKEN = import.meta.env.VITE_MAPBOX_PUBLIC_TOKEN;
if (!TOKEN) throw new Error('Missing VITE_MAPBOX_PUBLIC_TOKEN');
mapboxgl.accessToken = TOKEN;

export { mapboxgl };

export type EditMapHandles = {
  map: mapboxgl.Map;
  marker: mapboxgl.Marker;
};

export function initEditMap(
  container: HTMLElement,
  lng: number,
  lat: number,
  onMove: (lng: number, lat: number) => void,
): EditMapHandles {
  const map = new mapboxgl.Map({
    container,
    style: 'mapbox://styles/mapbox/streets-v12',
    center: [lng, lat],
    zoom: 16,
  });
  map.addControl(new mapboxgl.NavigationControl(), 'top-right');

  const marker = new mapboxgl.Marker({
    color: '#c4502b',
    draggable: true,
  })
    .setLngLat([lng, lat])
    .addTo(map);

  marker.on('dragend', () => {
    const { lng: newLng, lat: newLat } = marker.getLngLat();
    onMove(newLng, newLat);
  });

  return { map, marker };
}
